import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
/* Layout */
import Layout from '@/layout'

export const basicRouterMap = [
  {
    path: '/',
    redirect: '/index'
  },
  {
    path: '/index',
    component: Layout,
    children: [
      {
        path: '',
        component: () => import('@/views/index'),
        name: 'index',
        meta: {
          title: '首页',
          icon: 'manageBoard',
          i18n: 'sideBar.index'
        }
      }
    ]
  },
  {
    path: '/mediaScore',
    component: Layout,
    children: [
      {
        path: '',
        component: () => import('@/views/data/mediaScore/index.vue'),
        name: 'MediaScore',
        meta: {
          title: '媒体打分',
          icon: 'histogram',
          i18n: 'sideBar.mediaScore'
        }
      }
    ]
  },
  {
    path: '/weightedScore',
    component: Layout,
    children: [
      {
        path: '',
        component: () => import('@/views/weightedScore/index.vue'),
        name: 'WeightedScore',
        meta: {
          title: '媒体排名',
          icon: 'line chart',
          i18n: 'sideBar.mediaWeightedScore'
        }
      }
    ]
  },
  {
    path: '/login',
    name: 'login',
    hidden: true,
    component: () => import('@/views/login/index') // 懒加载
  },
  {
    component: Layout,
    path: '/no-permission',
    name: 'noPermission',
    children: [
      {
        path: '',
        name: 'noPermission',
        component: () => import('@/views/noPermission/index') // 懒加载
      }
    ]
  },
  {
    component: Layout,
    path: '/404',
    name: 'noFound',
    children: [
      {
        path: '',
        name: 'noFound',
        component: () => import('@/views/noFound/index') // 懒加载
      }
    ]
  }
]

export const dynamicRouterMap = []

// vue路由跳转错误：Error: Redirected when going from "/login" to "/home" via a navigation guard.
const originalPush = Router.prototype.push
Router.prototype.push = function push(location, onResolve, onReject) {
if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
return originalPush.call(this, location).catch(err => err)
}

export default new Router({
  routes: basicRouterMap
})
